var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"ACCESSIBILITY","name":"ACCESSIBILITY","data-command":_vm.$t('accessibility')}},[_c('img',{attrs:{"src":"/images/icons/accessibility.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('accessibility')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }